import { AffiliatePlacement } from "../data/affiliatePlacements";

export const AFFILIATE_DOMAINS = ["shopee.vn", "shp.ee", "s.shopee.vn"];

/**
 * Google yêu cầu link tiếp thị liên kết phải có rel="sponsored" (hoặc nofollow),
 * nếu không có thể bị coi là mua bán link.
 */
export const AFFILIATE_REL = "nofollow sponsored noopener noreferrer";

export const isAffiliateUrl = (href?: string): boolean => {
  if (!href) return false;
  try {
    const { hostname } = new URL(href, window.location.origin);
    return AFFILIATE_DOMAINS.some(
      (domain) => hostname === domain || hostname.endsWith(`.${domain}`)
    );
  } catch (error) {
    return false;
  }
};

interface AffiliateEventParams {
  productId: string;
  productName?: string;
  category?: string;
  placement: AffiliatePlacement;
  url?: string;
  trigger?: string;
}

/**
 * Bắn qua window.gtag đã có sẵn từ snippet trong public/index.html. Cố ý không
 * dùng firebase/analytics để tránh tạo nguồn dữ liệu thứ hai (double-count).
 * Adblock rất phổ biến trên máy sinh viên nên gtag có thể không tồn tại — mọi
 * thứ ở đây phải im lặng khi thiếu nó.
 */
const sendEvent = (name: string, params: Record<string, unknown>): void => {
  try {
    window.gtag?.("event", name, params);
  } catch (error) {
    // Tracking là tuỳ chọn, không bao giờ được làm hỏng luồng chính.
  }
};

/** Chống bắn trùng impression khi component re-render trong cùng một pageview. */
const seenImpressions = new Set<string>();

export const trackAffiliateImpression = (params: AffiliateEventParams): void => {
  const key = `${params.productId}:${params.placement}`;
  if (seenImpressions.has(key)) return;
  seenImpressions.add(key);
  sendEvent("affiliate_impression", {
    product_id: params.productId,
    product_name: params.productName,
    product_category: params.category,
    placement: params.placement,
    vendor: "shopee",
  });
};

export const trackAffiliateClick = (params: AffiliateEventParams): void => {
  sendEvent("affiliate_click", {
    product_id: params.productId,
    product_name: params.productName,
    product_category: params.category,
    placement: params.placement,
    vendor: "shopee",
    link_url: params.url,
  });
};

export const trackAffiliateDismiss = (
  placement: AffiliatePlacement,
  productId?: string
): void => {
  sendEvent("affiliate_dismiss", {
    placement,
    product_id: productId,
  });
};

export const trackAffiliateInterstitial = (
  action: "show" | "close" | "click",
  params: { productId: string; productName?: string; trigger?: string }
): void => {
  sendEvent(`affiliate_interstitial_${action}`, {
    product_id: params.productId,
    product_name: params.productName,
    trigger: params.trigger,
  });
};

export const trackAffiliateShopView = (): void => {
  sendEvent("affiliate_shop_view", { placement: "shop-page" });
};
